module.exports = __webpack_public_path__ + "img/7.a37641b1.png";